__webpack_require__.p = "https://partnership-frontend-nextjs-prod.ackoassets.com/next_assets/0563812c2af4558aebafdcada596a1747836314c/_next/";